module.exports = __webpack_public_path__ + "static/media/b3_p10_clickable.53aa19e9.png";